/**
 * @file useContactForm.hook.ts
 * @path apps/website/src/features/contact/hooks/useContactForm.hook.ts
 */
import { useState } from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { toast } from "sonner";
import { contactFormSchema, ContactFormData } from "../contact.types";
import { ContactService } from "../contact.service";

export const useContactForm = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const form = useForm<ContactFormData>({
    resolver: zodResolver(contactFormSchema),
    defaultValues: { firstName: "", lastName: "", email: "", message: "" },
  });

  const submitForm = async (data: ContactFormData) => {
    setIsSubmitting(true);
    try {
      await ContactService.sendMessage(data);
      toast.success("Message sent successfully!");
      form.reset();
    } catch {
      toast.error("Failed to send message");
    } finally {
      setIsSubmitting(false);
    }
  };

  return {
    form,
    isSubmitting,
    submitForm,
  };
};
